<!--能耗计算对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? '修改-盘管检查' : '创建-盘管检查'" :has-form="true" class="time-event-dialog-modal" top="15%" width="30%"
      @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="数据" name="second">
          <div class="border-main">
            <gs-form :model="form" label-width="90px" label-position="left" gap="small">
              <gs-form-item label="运行模式：" prop="target" class="form-item-radio">
                <gs-input v-model="form.mode"></gs-input>
              </gs-form-item>
              <gs-form-item label="状态反馈：" prop="target" class="form-item-radio">
                <gs-input v-model="form.stateString" placeholder="请用逗号隔开"></gs-input>
              </gs-form-item>
              <gs-form-item label="设定温度：" prop="target" class="form-item-radio">
                <div style="width: 100%;display: flex;height: 100%;align-items: center;">
                  <gs-input v-model="form.setMin" placeholder="最小值"></gs-input>-<gs-input v-model="form.setMax"
                    placeholder="最大值"></gs-input>
                </div>
              </gs-form-item>
              <gs-form-item label="送风温度：" prop="target" class="form-item-radio">
                <div style="width: 100%;display: flex;height: 100%;align-items: center;">
                  <gs-input v-model="form.supplyMin" placeholder="最小值"></gs-input>-<gs-input v-model="form.supplyMax"
                    placeholder="最大值"></gs-input>
                </div>
              </gs-form-item>
              <gs-form-item label="回风温度：" prop="target" class="form-item-radio">
                <div style="width: 100%;display: flex;height: 100%;align-items: center;">
                  <gs-input v-model="form.BackMin" placeholder="最小值"></gs-input>-<gs-input v-model="form.BackMax"
                    placeholder="最大值"></gs-input>
                </div>
              </gs-form-item>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!--   <gs-button type="primary" size="mini">帮 助</gs-button> -->
      </span>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      nodeId: "",
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      loading: false,
      activeName: 'first',
      name: '',
      description: '',
      form: {
        mode: '',
        state: '',
        stateString: '',
        setMin: "",
        setMax: "",
        supplyMin: '',
        supplyMax: '',
        BackMin: '',
        BackMax: ''
      },
      isEdit: false,
      visibleAdds: false,
    }
  },
  computed: {
    ...mapState({
      visible: 'coilDialogShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        this.isEdit = true
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'first'
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'FANCheck') {
          // this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description
          this.name = this.objectData.name
        } else {
          this.isEdit = false
          this.form = {
            showFromObject: '',
            showToObject: '',
            logInterval_value: '',
            tableId: '',
            batch: '', // 点位的名称
            cron: '',
            method: '',
            jobName: "",
            jobGroupName: "",
            nodeId: [],
            keyPrefix: [],
            result: ''
          }
          this.description = ''
          this.name = ''
          this.showFromObject = ""
          this.showToObject = ""
        }
      } else {
        this.isEdit = false
        this.form = {
          showFromObject: '',
          showToObject: '',
          logInterval_value: '',
          tableId: '',
          batch: '', // 点位的名称
          cron: '',
          method: '',
          jobName: "",
          jobGroupName: "",
          nodeId: [],
          keyPrefix: [],
          result: ''
        }
        this.description = ''
        this.name = ''
        this.showFromObject = ""
        this.showToObject = ""
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'COIL_DIALOG_HIDE'
    }),
    //主
    beforeClose() {
      this.close()
    },
    handleConfirm() {
      let _this = this
      if (this.name != "") {
        let obj = {
          name: this.name,
          type: "FANCheck",
          description: this.description,
          parentId: this.nodeData.id,
          attribute: {
            showFromObject: this.form.showFromObject,
            showToObject: this.form.showToObject,
            jobName: 6,
            jobGroupName: this.nodeData.name,
            tableId: this.nodeData.id,
            batch: this.form.batch,
            nodeId: this.form.nodeId,
            keyPrefix: this.form.keyPrefix,
            cron: this.form.cron,
            method: this.form.method,
            resultId: this.form.result
          }
        }
        if (_this.isEdit) {
          service.renamePoint(obj).then(res => {
            _this.close()
            this.$Message.success("修改成功！")
          })
        } else {
          service.newAddPoint(obj).then(res => {
            _this.close()
            this.$Message.success("创建成功！")
          })
        }
      } else {
        this.$Message.info("请填写完整信息！")
      }

    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },

    closeAdd() {

    },
  }
}
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/timeChart/coilDialog.vue